import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskProcessSeasonalIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M17.6877 3.22929C18.8075 3.1845 19.7742 4.0055 19.9118 5.11772C20.8258 12.5089 14.6961 18.8554 7.28613 18.2103L6.65138 20.7553C6.56801 21.0888 6.22973 21.2921 5.89625 21.2089C5.56277 21.1255 5.35948 20.7873 5.44269 20.4538L6.32063 16.9444C6.99606 14.2427 8.55715 11.8446 10.7553 10.1349L13.1363 8.28416C13.4077 8.07323 13.7983 8.12225 14.0093 8.3936C14.2203 8.665 14.1713 9.05562 13.8999 9.26668L11.5202 11.1186C9.61392 12.6014 8.24124 14.6588 7.59985 16.9821C14.1285 17.4248 19.4843 11.8069 18.6763 5.27093C18.6182 4.80147 18.2102 4.45438 17.7376 4.47324L13.6725 4.63619C8.89982 4.8271 5.32265 8.98544 5.7508 13.6584C5.78218 14.0009 5.55554 14.3223 5.21633 14.3787C4.87726 14.4351 4.55443 14.2056 4.51974 13.8636C3.97051 8.45034 8.10085 3.61189 13.6227 3.39101L17.6877 3.22929Z'
        />
    ),
})

TaskProcessSeasonalIcon.displayName = 'TaskProcessSeasonalIcon'
